<template>
  <section class="section">
    <div class="columns">
      <div class="column is-half">
        <system-widget
          :title="$t('serverStatus')"
          :refresh-interval="30000"
          :auto-refresh="true"
        />
      </div>
      <div class="column is-half">
        <log-rate-stats
          :refresh-interval="5000"
          :auto-refresh="true"
        />
      </div>
    </div>

    <log-volume-chart
      class="mt-4"
      :refresh-interval="60000"
      :auto-refresh="true"
    />

    <!-- <auto-update-settings-card class="mt-4" /> -->
  </section>
</template>

<script>
import SystemWidget from '@/components/SystemWidget'
import LogRateStats from '@/components/LogRateStats'
import LogVolumeChart from '@/components/LogVolumeChart'
import AutoUpdateSettingsCard from '@/components/AutoUpdateSettingsCard'

export default {
  name: 'Server',
  components: {
    SystemWidget,
    LogRateStats,
    LogVolumeChart,
    AutoUpdateSettingsCard
  }
}
</script>

<style lang="scss" scoped>
.section {
  padding: 1rem 1.5rem 1.5rem 1.5rem;
}

.columns {
  align-items: stretch;

  .column {
    display: flex;
    flex-direction: column;

    > * {
      flex: 1;
    }
  }
}
</style>
